(function () {
    'use strict';

    angular
        .module('app.shared')
        .directive('input', fileInputDirective);

    var isDefined = angular.isDefined,
        isUndefined = angular.isUndefined,
        noop = angular.noop,
        rAccept = /^(\.\w+)|((?:audio|video|image)\/\*)|(.*)$/,
        rWhitespace = /^\s*$/;

    fileInputDirective.$inject = ['$parse'];
    function fileInputDirective($parse) {
        return {
            restrict: 'E',
            require: ['?ngModel'],
            link: link
        };

        function link(scope, element, attr, ctrl) {
            ctrl = ctrl[0];
            if (ctrl && attr.type && attr.type.toLowerCase() === 'file'){
                ctrl.$render = noop;
                element.on('change', change);
                if (isDefined(attr.accept) || attr.sc3Accept)
                    attr.$observe('accept', acceptWatchAction);
            }

            function acceptWatchAction(value) {
                ctrl.$validators.accept = createAcceptValidator(value);
                ctrl.$validate();
            }

            function change(e) {
                var files = e.target.files || [],
                    value = attr.multiple ? files : files[0];

                ctrl.$setViewValue(value);
            }

            function createAcceptValidator(accept) {
                var matches = accept && accept.split(',').filter(isNotEmpty).map(createMatchFunction) || [];
                return validate;

                function isNotEmpty(value) {
                    return !rWhitespace.test(value);
                }

                function createMatchFunction(name) {
                    var match = rAccept.exec(name.trim()),
                        prop = match[1] ? 'name' : 'type',
                        expression = match[1] ? new RegExp('\\' + match[1] + '$', 'i') : match[2] ? new RegExp('^' + match[2].slice(0, -1), 'i') : match[3] ? new RegExp(match[3], 'i') : null;

                    return function isMatch(file) {
                        return expression.test(file[prop]);
                    }
                }

                function validate(file) {
                    return !file || !matches.length || matches.some(function (x) { return x(file); });
                }
            }
        }
    }
})();
